// --------------------------------------------------------
// CRIAÇÃO DE AGENDA - CriarAgenda
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from "react";
import LabelInput from "../../components/labelInput/LabelInput";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  Table,
  TableData,
  Text,
  TextLink,
} from "../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../components/UI/screenHeader/ScreenHeader";
import { RowContainer } from "../company/companyRegister/CompanyRegister.styled";
import SearchIcon from "@mui/icons-material/Search";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import Colors from "../../constants/Colors";
import AgendaProfissionalListItem from "../../components/criarAgenda/AgendaProfissionalListItem";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../..";
import * as agendaActions from "../../store/actions/agenda";
import CareLineDropdown from "../../components/dropdown/CareLineDropdown";
import { executeWithDelay } from "../../helpers/HelperFunctions";
import { Paths } from "../../enums/Paths";
import { useNavigate } from "react-router-dom";
import { CompanyListContainer } from "../company/CompanyList.styled";

// --------------------------------------------------------
// CRIAÇÃO DE AGENDA INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
import BackButton from "../../components/UI/buttons/BackButton";

function AgendaList(): JSX.Element {
  // --------------------------------------------------------
  // CRIAÇÃO DE AGENDA PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [searchQuery, setSearchQuery] = useState("");
  const { isMobile } = useResponsiveInfo();
  const [isLoading, setIsLoading] = useState(false);

  const [currentRoleFilter, setCurrentRoleFilter] = useState<any>({
    nome: "Todos",
    id: "",
  });

  const { agendasProfissionais, rolesComboFilter } = useSelector(
    (state: any) => state.agenda
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setIsLoading(true);

    await dispatch(agendaActions.fetchFilterDropdownData());
    await dispatch(agendaActions.fetchProfissionaisAgenda());

    setIsLoading(false);
  }, [dispatch, isLoading]);

  const filterByProfissional = useCallback(async () => {
    if (searchQuery.length >= 3 || searchQuery === "") {
      executeWithDelay(500, async () => {
        await dispatch(agendaActions.filterAgendasByProfissional(searchQuery));
      });
    }
  }, [searchQuery]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterByProfissional();
  }, [searchQuery]);

  useEffect(() => {
    filterByRole();
  }, [currentRoleFilter]);

  const filterByRole = useCallback(async () => {
    await dispatch(agendaActions.filterAgendasByRole(currentRoleFilter.id));
  }, [currentRoleFilter]);

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <BackButton onClick={() => navigate(Paths.CollaboratorInitial)} />
        <ScreenHeader
          screenTitle={"Criação de Agenda"}
          hasRightButton={false}
          rightButtonText={""}
          onRightButtonClick={() => {}}
        />
        <RowContainer
          style={{ marginBottom: "1%", justifyContent: "space-between" }}
        >
          <LabelInput
            value={searchQuery}
            style={{ marginRight: 2 }}
            placeholder="Busca de nome"
            onChangeText={(event: any) => {
              setSearchQuery(event.target.value);
            }}
            rightIcon={<SearchIcon />}
          />
          <CareLineDropdown
            value={currentRoleFilter}
            onChange={(value: any) => {
              setCurrentRoleFilter(value);
            }}
            items={rolesComboFilter}
            disabled={false}
            placeholder="Filtrar por tipo de profissional"
            containerStyle={{
              marginRight: 10,
              width: isMobile ? "100%" : 310,
              marginTop: isMobile ? 12 : 0,
            }}
          />
        </RowContainer>
        {!isMobile && (
          <Table>
            <TableData width={"12%"} style={{ verticalAlign: "middle" }}>
              <Text bold>Nome</Text>
            </TableData>
            <TableData width={"30%"} style={{ verticalAlign: "middle" }}>
              <Text bold>Tipo de Profissional</Text>
            </TableData>
          </Table>
        )}
        {agendasProfissionais.length === 0 && (
          <Text>
            Profissional de saúde não localizado. Revisar perfis do colaborador
          </Text>
        )}
        <CompanyListContainer>
          <>
            {agendasProfissionais.map((agenda: any, index: number) => {
              return <AgendaProfissionalListItem item={agenda} key={index} />;
            })}
          </>
        </CompanyListContainer>
      </GeneralContainer>
    </ContainerWithSidebar>
  );
}

export default AgendaList;
